import { render, staticRenderFns } from "./EditarContenidoModulos.vue?vue&type=template&id=a986ba86"
import script from "./EditarContenidoModulos.vue?vue&type=script&lang=js"
export * from "./EditarContenidoModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports